import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import { LuSearch, LuCalendar, LuUser, LuClock, LuAlertTriangle } from "react-icons/lu";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuCircleAlert } from "react-icons/lu"
//import { CSSTransition } from 'react-transition-group';
import { getDepartmentsFindings, getDepartmentsActionData, getDepartments, getDepartmentsAction, addActionComments, editActionComments } from "../../store/actions/departmentActions";
import { markFindingsOpen, markFindingsComplete, addActionsFromFindings, editActionProgress, editAction } from "../../store/actions/riskActions";

import debounce from "lodash/debounce";
import { Disable } from 'react-disable';


import "./Gantt.css";

import Select from 'react-select'


import ActionOverlay from "../Action/ActionOverlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};



const statusMeta = {
    "Not started": { cls: "bg-gray-100 text-gray-700 border-gray-200" },
    "In progress": { cls: "bg-blue-100 text-blue-700 border-blue-200" },
    "Completed": { cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
    "Problem": { cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

function chipCls(label) {
    const m = label && statusMeta[label];
    return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${m ? m.cls : "bg-gray-100 text-gray-700 border-gray-200"
        }`;
}

function isCompleted(label) {
    return label === "Completed";
}

function isBehind(t) {
    try {
        if (t.styles && t.styles.backgroundColor === "#F07167") return true; // backend hint
        const start = new Date(t.start);
        const end = new Date(t.end);
        const now = new Date();
        const total = end - start;
        const elapsed = now - start;
        const frac = total > 0 ? elapsed / total : 0;
        const pct = Number(t.progress || 0);
        return pct < frac * 100 && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}

function isOverdue(t) {
    try {
        return new Date(t.end) < new Date() && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}




const FindingsComponent = (props) => {


    const { markFindingsOpenFN, markFindingsCompleteFN, makeActionsFN, findings, actions_stats, getDepartmentsFindingsFN, getDepartmentsActionDataFN, departments, getDepartmentsFN, getDepartmentsActionFN, actions, addActionCommentsFN, editActionFN, editActionCommentsFN, activeDepartmentId, profile } = props;

    ////console.log("ACTIONS GANTT :", actions);
    // Step 1: Initialize state for input values
    const [tasks, setTasks] = useState([]);

    const [isLoading, setIsLoading] = useState(true);


    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);


    // const [taskDescription, setTaskDescription] = useState("");


    // eslint-disable-next-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (activeDepartmentId) {
            //alert(activeDepartmentId);
            if (profile.role !== "User") {
                getDepartmentsActionFN(activeDepartmentId);
                getDepartmentsFindingsFN(activeDepartmentId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDepartmentId]);

    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    const [activeDepartment, setActiveDepartment] = useState(activeDepartmentId ? activeDepartmentId : null);

    useEffect(() => {

        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {


        if (profile?.department_id && (profile.role === "User")) {
            //alert(profile.department_id);
            setActiveDepartment(profile.department_id);
            console.log(profile.department_id)
            getDepartmentsActionFN(profile.department_id);
            getDepartmentsFindingsFN(activeDepartmentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {


        if (activeDepartmentId) {
            setActiveDepartment(activeDepartmentId)

        }
    }, [activeDepartmentId]);

    const ganttWrapperRef = useRef(null);

    useEffect(() => {
        if (ganttWrapperRef.current) {
            // Use timeout to wait for Gantt to finish its own scroll logic
            setTimeout(() => {
                ganttWrapperRef.current.scrollLeft = 0;
            }, 100); // 100ms usually works — adjust if needed
        }
    }, [tasks]); // Runs every time tasks change

    /*
    useEffect(() => {
        if (departments?.length > 0) {
            //alert(1)
            setActiveDepartment(departments[0].department_id);
            getDepartmentsActionFN(departments[0].department_id);
            //////console.log(departments[0].department_id, departments);
            //select first department
        }
    }, [departments]);

    */


    function normalizeTasks(src) {
        const raw = Array.isArray(src) ? src : [];
        // keep only real action rows
        const onlyTasks = raw.filter(
            (t) => t && t.type === "task" && (t.iid != null || t.action_id != null)
        );
        // de-dup by iid/action_id
        const byId = new Map();
        for (const t of onlyTasks) {
            const key = t.iid ?? t.action_id ?? t.id;
            if (!byId.has(key)) byId.set(key, t);
        }
        let out = Array.from(byId.values());

        // guard: sometimes a project slips in; drop rows where name === project (if you never intend that)
        out = out.filter((t) => t.name !== t.project);

        // optional: drop untitled
        out = out.filter((t) => (t.name || "").trim().length > 0);

        return out;
    }






    // local UI state
    const [q, setQ] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [onlyMine, setOnlyMine] = useState(false);

    const counts = useMemo(() => {
        let open = 0,
            closed = 0;
        tasks.forEach((t) => (isCompleted(t.progressLabel) ? closed++ : open++));
        return { open, closed, total: tasks.length };
    }, [tasks]);

    const meId = profile && profile.user_id ? Number(profile.user_id) : null;

    const filtered = useMemo(() => {
        let list = [...tasks];

        if (statusFilter !== "All") {
            list = list.filter((t) => (t.progressLabel || "Not started") === statusFilter);
        }

        if (q.trim()) {
            const L = q.toLowerCase();
            list = list.filter(
                (t) => (t.name || "").toLowerCase().includes(L) || (t.project || "").toLowerCase().includes(L)
            );
        }

        if (onlyMine && meId) {
            list = list.filter(
                (t) => (t.assignees || []).some((u) => Number(u.id) === meId) || (t.riskOwner && Number(t.riskOwner.id) === meId)
            );
        }

        // prioritize overdue/behind, then nearest due date
        list.sort((a, b) => {
            const sa = isOverdue(a) ? 2 : isBehind(a) ? 1 : 0;
            const sb = isOverdue(b) ? 2 : isBehind(b) ? 1 : 0;
            if (sa !== sb) return sb - sa;
            return new Date(a.end) - new Date(b.end);
        });

        return list;
    }, [tasks, q, statusFilter, onlyMine, meId]);



    const getControlTitle = (f) =>
        f.control_title && f.control_title.trim()
            ? f.control_title.trim()
            : (f.control_id ? `Control #${f.control_id}` : "—");

    const normalize = (s) => (s || "").toString().toLowerCase().trim();

    // ---- component body ----
    const [qFind, setQFind] = useState("");
    const filteredFindings = (findings || []).filter((f) => {
        const q = normalize(qFind);
        if (!q) return true;
        return (
            normalize(f.risk_title).includes(q) ||
            normalize(getControlTitle(f)).includes(q) ||
            normalize(f.finding_text).includes(q)
        );
    });


    const [selected, setSelected] = useState(new Set());

    // stable row key (matches your original intent)
    const rowKey = (f) => `${f.control_id}-${f.risk_id}-${f.source}-${f.created_at}`;

    // convenience
    const allIds = filteredFindings.map(rowKey);
    const allSelected = selected.size > 0 && allIds.every((id) => selected.has(id));

    const toggleRow = (id) => {
        setSelected((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const toggleAll = () => {
        setSelected((prev) => {
            if (allIds.length === 0) return new Set();
            const next = new Set(prev);
            const selectingAll = !allIds.every((id) => next.has(id));
            if (selectingAll) {
                allIds.forEach((id) => next.add(id));
            } else {
                allIds.forEach((id) => next.delete(id));
            }
            return next;
        });
    };

    const clearSelection = () => setSelected(new Set());

    // map selected ids back to finding objects
    const selectedFindings = filteredFindings.filter((f) => selected.has(rowKey(f)));

    const handleMakeActions = async () => {
        if (!selectedFindings.length) return;
        await makeActionsFN?.(selectedFindings);
        clearSelection();
    };

    const handleMarkComplete = async () => {
        if (!selectedFindings.length) return;
        try {
            await markFindingsCompleteFN?.(selectedFindings);
            // instant refresh
            await getDepartmentsFindingsFN?.(activeDepartmentId);
        } finally {
            clearSelection();
        }
    };

    const handleMarkOpen = async () => {
        const items = filteredFindings.filter((f) => selected.has(rowKey(f)));
        if (!items.length) return;
        try {
            await markFindingsOpenFN?.(items);
            // instant refresh
            await getDepartmentsFindingsFN?.(activeDepartmentId);
        } finally {
            clearSelection();
        }
    };

    const [statusView, setStatusView] = useState("All"); // "All" | "Open" | "Completed"

    // helper: returns true if finding is completed
    const isCompletedFinding = (f) => (f.status?.toLowerCase?.() === "completed");

    // if you already compute `filteredFindings`, wrap it once more by status:
    const statusFilteredFindings = useMemo(() => {
        if (statusView === "All") return filteredFindings;
        if (statusView === "Completed") return filteredFindings.filter(isCompletedFinding);
        // "Open"
        return filteredFindings.filter((f) => !isCompletedFinding(f));
    }, [filteredFindings, statusView]);


    function priorityChip(label) {
        if (!label) return null;
        const map = {
            Critical: "bg-rose-50 text-rose-700 border-rose-200",
            High: "bg-amber-50 text-amber-700 border-amber-200",
            Medium: "bg-blue-50 text-blue-700 border-blue-200",
            Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
        };
        const cls = map[label] || "bg-gray-50 text-gray-700 border-gray-200";
        return (
            <span className={`inline-flex items-center text-[10px] px-1.5 py-0.5 rounded border ${cls}`}>
                {label}
            </span>
        );
    }

    return (
        <div className="w-full">

            {/* Bulk toolbar (appears when any row selected) */}
            {selected.size > 0 && (
                <div className="mx-10 mt-6 mb-3 flex items-center justify-between">
                    <div className="text-sm text-[#3b3b3b]">
                        <span className="font-medium">{selected.size}</span> selected
                    </div>
                    <div className="flex items-center gap-2">
                        <button onClick={handleMakeActions} className="px-3 py-1.5 text-sm rounded-lg border border-gray-300 hover:bg-gray-50">Make Action</button>
                        <button onClick={handleMarkComplete} className="px-3 py-1.5 text-sm rounded-lg border border-gray-300 hover:bg-gray-50">Mark Complete</button>
                        <button onClick={handleMarkOpen} className="px-3 py-1.5 text-sm rounded-lg border border-gray-300 hover:bg-gray-50">Reopen</button>
                        <button onClick={clearSelection} className="px-3 py-1.5 text-sm rounded-lg text-gray-500 hover:text-[#3b3b3b]">Clear</button>
                    </div>
                </div>
            )}

            {/* Top filters / counts */}
            <div className="mx-10 mt-6 mb-3 flex items-center justify-between">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                    {/* (optional) selected count moved out of toolbar if you prefer */}
                </div>

                <div className="flex items-center gap-2">
                    <select
                        value={statusView}
                        onChange={(e) => setStatusView(e.target.value)}
                        className="border border-gray-300 rounded-lg text-sm px-2 py-1.5 focus:outline-none focus:ring-0 focus:border-gray-400"
                    >
                        <option>All</option>
                        <option>Open</option>
                        <option>Completed</option>
                    </select>
                </div>
            </div>

            {/* Table */}
            <div className="table-wrapper mx-10 mt-8 shadow-xl rounded-lg overflow-hidden bg-white border border-gray-300">
                {/* Header */}
                <div className="grid grid-cols-[32px_1.2fr_0.9fr_2.2fr] gap-4 px-4 py-4 bg-gray-50 text-xs font-semibold text-gray-700 border-b border-gray-300">
                    <div className="flex items-center justify-center">
                        <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={toggleAll}
                            className="h-4 w-4 rounded border-gray-300 text-[#3b3b3b] focus:ring-0"
                            aria-label="Select all"
                        />
                    </div>
                    <div className="-ml-1">Risk</div>
                    <div className="-ml-1">Control</div>
                    <div className="-ml-1">Finding</div>
                </div>

                {/* Rows */}
                <div className="divide-y divide-gray-300">
                    {statusFilteredFindings.length > 0 ? (
                        statusFilteredFindings.map((f) => {
                            const id = rowKey(f);
                            const isChecked = selected.has(id);
                            const completed = isCompletedFinding(f);

                            return (
                                <div
                                    key={id}
                                    className={`grid grid-cols-[32px_1.2fr_0.9fr_2.2fr] gap-4 items-start px-4 py-4 transition-colors duration-200
            ${isChecked ? "bg-[#F3F6F8]" : "hover:bg-[#F8F8F8]"}
            ${completed ? "" : ""}`}
                                >
                                    {/* Checkbox */}
                                    <div className="flex items-center justify-center">
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={() => toggleRow(id)}
                                            className="h-4 w-4 rounded border-gray-300 text-[#3b3b3b] focus:ring-0"
                                            aria-label="Select row"
                                        />
                                    </div>

                                    {/* Risk */}
                                    <div className="min-w-0 -ml-1">
                                        <div className="text-sm text-gray-800 font-medium truncate">
                                            {f.risk_title || "—"}
                                        </div>
                                        <div className="mt-0.5 flex items-center gap-2">
                                            {f.source && (
                                                <span className="inline-flex items-center text-[10px] px-1.5 py-0.5 rounded border border-gray-200 bg-gray-50 text-gray-600">
                                                    {f.source === "secondline" ? "Second line" : "First line"}
                                                </span>
                                            )}
                                            {/* NEW: priority chip from backend */}
                                            {priorityChip(f.priority)}
                                        </div>
                                    </div>

                                    {/* Control — title only */}
                                    <div className="min-w-0 -ml-1">
                                        <div className={`text-sm truncate ${completed ? "text-gray-500" : "text-gray-700"}`}>
                                            {getControlTitle(f)}
                                        </div>
                                    </div>

                                    {/* Finding */}
                                    <div className="min-w-0 -ml-1">
                                        <div className={`text-sm leading-5 ${completed ? "text-gray-500" : "text-gray-800"}`}>
                                            {f.finding_text || "—"}
                                        </div>

                                        {f.recommendation_text ? (
                                            <div className="mt-1 text-[12px] text-gray-600">
                                                <span className="font-medium">Recommendation: </span>
                                                <span>{f.recommendation_text}</span>
                                            </div>
                                        ) : null}

                                        {/* Row-level quick action when completed */}
                                        {completed && (
                                            <button
                                                type="button"
                                                onClick={() => markFindingsOpenFN?.([{ finding_id: f.finding_id ?? f.id, ...f }])}
                                                className="mt-2 text-[12px] underline text-[#0E4A62] hover:opacity-80"
                                            >
                                                Reopen this finding
                                            </button>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="grid grid-cols-[32px_1.2fr_0.9fr_2.2fr] gap-4 px-4 py-10">
                            <div className="col-span-full text-center text-gray-500 text-sm">
                                No findings to show.
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

};




const mapStateToProps = (state) => {
    console.log(state.department)
    return {
        departments: state.department.departments,
        actions: state.department.actions,
        profile: state.profile.profile,
        findings: state.department.finding_data?.findings
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        getDepartmentsActionFN: (department_id) => dispatch(getDepartmentsAction(department_id)),
        getDepartmentsActionDataFN: (department_id) => dispatch(getDepartmentsActionData(department_id)),
        getDepartmentsFindingsFN: (department_id) => dispatch(getDepartmentsFindings(department_id)),
        addActionCommentsFN: (action_id, comments, department_id) => dispatch(addActionComments(action_id, comments, department_id)),
        editActionCommentsFN: (comment_iid, comments, department_id) => dispatch(editActionComments(comment_iid, comments, department_id)),
        editActionProgressFN: (action_id, progress) => dispatch(editActionProgress(action_id, progress)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        makeActionsFN: (items) => dispatch(addActionsFromFindings(items)),
        markFindingsCompleteFN: (items) => dispatch(markFindingsComplete(items)),
        markFindingsOpenFN: (items) => dispatch(markFindingsOpen(items)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(FindingsComponent);
